import { Component, OnInit, Inject } from "@angular/core";
import {
  Validators,
  FormBuilder,
  ValidatorFn,
  FormGroup,
  ValidationErrors
} from "@angular/forms";
import { MainService } from "src/app/Services/service.service";
import { Router, ActivatedRoute } from "@angular/router";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { Location } from "@angular/common";

@Component({
  selector: "app-new-password",
  templateUrl: "./new-password.component.html",
  styleUrls: ["./new-password.component.css"]
})
export class NewPasswordComponent implements OnInit {
  newPasswordForm = this.fb.group(
    {
      email: [
        null,
        Validators.compose([Validators.required, Validators.email])
      ],
      password: [
        null,
        Validators.compose([Validators.required, Validators.minLength(5)])
      ],
      passwordConfirm: [null, Validators.required]
    },
    { validators: registrationFormValidate }
  );

  private code: string;

  constructor(
    private fb: FormBuilder,
    public services: MainService,
    private location: Location,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: { code: string },
    public dialogRef: MatDialogRef<NewPasswordComponent>
  ) {}

  ngOnInit() {
    this.code = this.data.code; //this.route.snapshot.paramMap.get("code");
    if (this.code && this.code != "") {
      this.services.userService
        .getEmailFromCode(this.code)
        .then(r => {
          this.newPasswordForm.controls["email"].setValue(r);
        })
        .catch(e => {
          this.services.route.navigate([""]).then(() => {
            this.services.showError(e);
          });
        });
    } else {
      this.services.route.navigate([""]);
    }
  }

  isEmailNotValid() {
    return (
      this.newPasswordForm.controls["email"].hasError("required") ||
      this.newPasswordForm.controls["email"].hasError("email")
    );
  }

  getEmailErrorMessage() {
    return this.newPasswordForm.controls["email"].hasError("required")
      ? "Email is required"
      : this.newPasswordForm.controls["email"].hasError("email")
      ? "Enter valid email address"
      : "";
  }

  isPasswordNotValid() {
    return (
      this.newPasswordForm.controls["password"].hasError("required") ||
      this.newPasswordForm.controls["password"].hasError("minlength") ||
      this.newPasswordForm.hasError("passwordConfirmed")
    );
  }

  getPasswordErrorMessage() {
    return this.newPasswordForm.controls["password"].hasError("required")
      ? "Password is required"
      : this.newPasswordForm.controls["password"].hasError("minlength")
      ? "Password must have at 5 chars length."
      : this.newPasswordForm.hasError("passwordConfirmed")
      ? "Password and Confirmation must be equal."
      : "";
  }

  isPasswordConfirmNotValid() {
    var res =
      this.newPasswordForm.controls["passwordConfirm"].hasError("required") ||
      //  || this.registrationForm.controls['passwordConfirm'].hasError('minlength')
      this.newPasswordForm.hasError("passwordConfirmed");

    console.log(`confval: ${res}`);
    return res;
  }

  getPasswordConfirmErrorMessage() {
    var res = this.newPasswordForm.controls["passwordConfirm"].hasError(
      "required"
    )
      ? "Password Confirmation is required"
      : // this.registrationForm.controls['passwordConfirm'].hasError('minlength') ? 'Password Confirmation must have at 5 chars length.' :
      this.newPasswordForm.hasError("passwordConfirmed")
      ? "Password and Confirmation must be equal."
      : "";
    console.log(`confm: ${res}`);
    return res;
  }

  onSubmit() {
    if (!this.newPasswordForm.invalid) {
      this.services.userService
        .newPassword(
          this.newPasswordForm.controls["email"].value,
          this.code,
          this.newPasswordForm.controls["password"].value,
          this.newPasswordForm.controls["passwordConfirm"].value,
          ""
        )
        .then(r => {
          this.dialogRef.close();
          this.location.go("/");
          this.services.route.navigate([r]).then(() => {
            this.services
              .showInformation(
                "Your password has been changed successfully!"
              )
              .afterDismissed()
              .subscribe(() => {
                this.services.showLogin();
              });
          });
        })
        .catch(e => {
          this.services.showError(e);
        });
    }
  }
}

export const registrationFormValidate: ValidatorFn = (
  control: FormGroup
): ValidationErrors | null => {
  const p = control.get("password");
  const pc = control.get("passwordConfirm");
  let res =
    p && pc && pc.value === p.value ? null : { passwordConfirmed: true };
  console.log(`passwordConfirmed: ${res}`);
  console.log(`pass: ${p.value} , pc: ${pc.value}`);

  return res;
};
